<div class="max-w-3xl">
    <!-- Transport selector -->
    <div class="mb-4 flex items-center justify-between gap-4">
        <div class="flex items-center gap-2">
            <span>{{ 'Printers.transport' | transloco }}</span>
            <mat-button-toggle-group [value]="transport" (change)="transport=$event.value; onTransportChange()"
                                     name="transport">
                <mat-button-toggle value="serial">Serial</mat-button-toggle>
                <mat-button-toggle value="usb">USB</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="flex gap-2">
            <button *ngIf="!selectionMode" mat-stroked-button color="primary" (click)="testPrint()"
                    [disabled]="!supportedActive || loading || !lastUsed?.vendorId || (printers?.length === 0)">
                <mat-icon svgIcon="heroicons_outline:printer" class="mr-2"></mat-icon>
                <span *ngIf="!isMobileResolution">{{ 'Printers.test_print' | transloco }}</span>
            </button>
            <button mat-flat-button color="primary" (click)="addPrinterToGranted()" [disabled]="!supportedActive">
                <mat-icon svgIcon="heroicons_outline:plus" class="mr-2"></mat-icon>
                <span *ngIf="!isMobileResolution">{{ 'Printers.add_printer' | transloco }}</span>
            </button>
        </div>
    </div>

    <div class="mb-6">
        <div *ngIf="!supportedActive" class="text-red-600 mt-2">
            <ng-container *ngIf="transport==='serial'; else usbUnsup">{{ 'Printers.unsupported_serial' | transloco }}
            </ng-container>
            <ng-template #usbUnsup>{{ 'Printers.unsupported_usb' | transloco }}</ng-template>
        </div>
        <div *ngIf="loading" class="text-secondary mt-2">{{ 'Printers.loading' | transloco }}</div>
    </div>

    <div class="mb-8">
        <div class="border rounded">
            <ng-container *ngIf="selectionMode; else normalList">
                <mat-radio-group (change)="onCandidateChange($event.value)">
                    <div class="divide-y">
                        <div *ngFor="let p of printers" class="px-4 py-3 flex items-center justify-between">
                            <div>
                                <div class="font-medium">
                                    {{ getPrinterName(p) }}
                                </div>
                                <div class="text-sm text-secondary">
                                    {{
                                        'Printers.usb_label' | transloco: {
                                            vendor: (p.info?.usbVendorId || '—'),
                                            product: (p.info?.usbProductId || '—')
                                        }
                                    }}
                                </div>
                            </div>
                            <div class="flex items-center gap-2">
                                <mat-radio-button color="primary" [value]="p"></mat-radio-button>
                            </div>
                        </div>
                        <div *ngIf="!loading && printers?.length === 0" class="px-4 py-3 text-secondary">
                            {{ 'Printers.no_granted_printers' | transloco }}
                        </div>
                    </div>
                </mat-radio-group>
                <div class="px-4 py-3 flex justify-end gap-2 border-t">
                    <button mat-stroked-button color="primary" (click)="testSelected()" [disabled]="!selectedCandidate">
                        <mat-icon svgIcon="heroicons_outline:printer" class="mr-2"></mat-icon>
                        Testar
                    </button>
                    <button mat-flat-button color="primary" (click)="approveSelection()"
                            [disabled]="!selectedCandidate">
                        Selecionar
                    </button>
                </div>
            </ng-container>
            <ng-template #normalList>
                <div class="divide-y">
                    <div *ngFor="let p of printers" class="px-4 py-3 flex items-center justify-between">
                        <div>
                            <div class="font-medium">
                                {{ getPrinterName(p) }}
                            </div>
                            <div class="text-sm text-secondary">
                                {{
                                    'Printers.usb_label' | transloco: {
                                        vendor: (p.info?.usbVendorId || '—'),
                                        product: (p.info?.usbProductId || '—')
                                    }
                                }}
                            </div>
                        </div>
                        <div class="flex items-center gap-1">
                            <button mat-icon-button (click)="editAlias(p)"
                                    [attr.title]="('Printers.set_alias' | transloco)">
                                <mat-icon [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="setDefault(p)"
                                    [disabled]="!supportedActive">
                                <mat-icon *ngIf="lastUsed?.productId !== p.info.usbProductId"
                                          [svgIcon]="'heroicons_outline:star'"></mat-icon>
                                <mat-icon *ngIf="lastUsed?.productId === p.info.usbProductId"
                                          [svgIcon]="'heroicons_solid:star'"></mat-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!loading && printers?.length === 0" class="px-4 py-3 text-secondary">
                        {{ 'Printers.no_granted_printers' | transloco }}
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
